export const URLS = {
  AUTH_COLLECTING_COMPANIES: '/wasteManagement/admin/collectingCompanies',
  AUTH_DAILY_REPORTS: '/wasteManagement/records/dailyReports',
  AUTH_METI_REPORTS: '/wasteManagement/records/metiReports',
  AUTH_COLLECTOR_REPORTS: '/wasteManagement/records/collectorReports',
  AUTH_EXTERNAL_ARTICLES_REPORT: '/wasteManagement/records/externalArticlesReports',
  AUTH_ACCOMPANYING_NOTES: '/wasteManagement/records/accompanyingNotes',
  AUTH_ACCOMPANYING_NOTES_REPORT: '/wasteManagement/reports/accompanyingNotes',
  AUTH_DAILY_REPORTS_REPORT: '/wasteManagement/reports/dailyReports',
  AUTH_COLLECTOR_REPORTS_REPORT: '/wasteManagement/reports/collectorReports',
  AUTH_NO_DAILY_REPORTS: '/wasteManagement/reports/noDailyReports',
  AUTH_EXTERNAL_ARTICLES_REPORT_REPORT: '/wasteManagement/reports/externalArticlesReports'
}

export enum PermissionRoles {
  GG_RO_DEX_WMP_USER = 'GG_RO_DEX_WMP_USER',
  GG_RO_DEX_WMP_ADMIN = 'GG_RO_DEX_WMP_ADMIN'
}

export const collectingCompaniesRoles = {
  createRoles: [PermissionRoles.GG_RO_DEX_WMP_ADMIN],
  editRoles: [PermissionRoles.GG_RO_DEX_WMP_ADMIN],
  deleteRoles: [PermissionRoles.GG_RO_DEX_WMP_ADMIN]
}

export const dailyReportsRoles = {
  createRoles: [PermissionRoles.GG_RO_DEX_WMP_USER],
  editRoles: [PermissionRoles.GG_RO_DEX_WMP_USER],
  deleteRoles: [PermissionRoles.GG_RO_DEX_WMP_USER]
}

export const collectorReportsRoles = {
  createRoles: [PermissionRoles.GG_RO_DEX_WMP_USER],
  editRoles: [PermissionRoles.GG_RO_DEX_WMP_USER],
  deleteRoles: [PermissionRoles.GG_RO_DEX_WMP_USER]
}

export const accompanyingNotesRoles = {
  createRoles: [PermissionRoles.GG_RO_DEX_WMP_USER],
  editRoles: [PermissionRoles.GG_RO_DEX_WMP_USER],
  deleteRoles: [PermissionRoles.GG_RO_DEX_WMP_USER]
}

export const externalArticlesReportsRoles = {
  createRoles: [PermissionRoles.GG_RO_DEX_WMP_USER],
  editRoles: [PermissionRoles.GG_RO_DEX_WMP_USER],
  deleteRoles: [PermissionRoles.GG_RO_DEX_WMP_USER]
}

export const HYPER_STORE_TYPE = 'HYPER'
